export default __webpack_public_path__ + "static/media/EN.ac0dea97.svg";